var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5869 15.8281C12.0352 15.8281 12.2461 15.5205 12.2461 15.0986V14.5625C12.2637 13.332 12.6855 12.7783 14.1445 11.7588C15.7441 10.6426 16.5967 9.52637 16.5967 7.90918C16.5967 5.41309 14.5576 3.83984 11.9736 3.83984C9.97852 3.83984 8.28223 4.89453 7.61426 6.61719C7.45605 7.0127 7.39453 7.37305 7.39453 7.66309C7.39453 8.04102 7.61426 8.2959 8.00977 8.2959C8.35254 8.2959 8.57227 8.10254 8.66895 7.75977C9.04688 5.9668 10.3037 5.07031 11.9385 5.07031C13.7842 5.07031 15.2432 6.2041 15.2432 7.90918C15.2432 9.15723 14.5049 9.94824 13.2129 10.8887C11.7275 11.9434 10.9014 12.8838 10.9014 14.4131V15.1074C10.9014 15.5381 11.1387 15.8281 11.5869 15.8281ZM11.5957 20.4951C12.1582 20.4951 12.6064 20.0381 12.6064 19.4844C12.6064 18.9307 12.1582 18.4736 11.5957 18.4736C11.0508 18.4736 10.5938 18.9307 10.5938 19.4844C10.5938 20.0381 11.0508 20.4951 11.5957 20.4951Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmark);
export default __webpack_public_path__ + "static/media/Question mark.bd84fdc9e2400b0774b5305da6170d9a.svg";
export { ForwardRef as ReactComponent };